import cx from 'classnames'
import React from 'react'
import { Field, Form } from 'react-final-form'

import { Alert } from '@cinch-labs/design-system'
import { Outline, Primary } from '@cinch/oxd-components/button/src'

import Modal from '@cinch/oxd-components/modal/src'

import * as styles from './save-search-modal.module.css'
import { TextFieldWrapper } from '../../final-form-wrappers/src'

export interface Props {
  onClose?: () => void
  onCancel?: () => void
  onSubmit?: (formValues: any) => void
  searchName?: string
}

const SaveSearchModal: React.FC<Props> = ({
  onClose = () => undefined,
  onCancel = () => undefined,
  onSubmit = () => undefined,
  searchName = '',
}) => {
  return (
    <Modal title={'Save this search'} onClose={onClose}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ searchName }}
        render={({ handleSubmit, pristine, submitting, submitFailed, submitError, invalid }) => (
          <form onSubmit={handleSubmit} className={styles.form} name="save-search">
            <Field
              name="searchName"
              type="text"
              fullWidth={true}
              component={TextFieldWrapper}
              oxford={true}
              required={true}
              label="Choose a name for this search"
              placeholder="Land Rovers"
            />

            {submitFailed && submitError && <Alert oxford={true}>{submitError}</Alert>}

            <div className={styles.actions}>
              <Outline
                className={cx(styles.buttons, 'test-save-search-modal-cancel')}
                isFullWidth={true}
                type="button"
                onClick={onCancel}
              >
                Cancel
              </Outline>

              <Primary
                oxdClassName={styles.buttons}
                isFullWidth={true}
                type="submit"
                disabled={pristine || invalid || submitting}
                oxford={true}
              >
                Save
              </Primary>
            </div>
          </form>
        )}
      />
    </Modal>
  )
}

export default SaveSearchModal
